import {
  setWrittenCompanyName,
  setUserFullName,
  setInvitedEmployees,
  finalizeCompanyCreation,
  setRestrictedMailDomains,
} from './GetStartedThunks';

export const GetStartedActions = {
  setWrittenCompanyName,
  setUserFullName,
  setInvitedEmployees,
  finalizeCompanyCreation,
  setRestrictedMailDomains,
};
